/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

export default class ChooseTableRow extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired,  // needs to be a component containing a table
    resetSelection: PropTypes.bool
  }

  static defaultProps = {
    resetSelection: false
  }

  constructor(props) {
    super(props)

    this.listingComponentRef = React.createRef()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.resetSelection && !this.props.resetSelection) {
      this.resetRowSelection()
    }
  }

  getTable = () => {
    if (this.listingComponentRef.current) {
      return this.listingComponentRef.current.querySelector('table')
    } else {
      return null
    }
  }

  getTableRows = () => {
    if (this.listingComponentRef.current) {
      return this.listingComponentRef.current.childNodes[0].querySelectorAll('tr')
    } else {
      return null
    }
  }

  addClickHandler = (row, index) => {
    let markCurrentRowAsSelected = this.markCurrentRowAsSelected
    row.addEventListener('click', function f() {  //NOTE: using 'function' keyword in order to name anonymous function and be able to pass as arg to removeEventListener
      markCurrentRowAsSelected(row, index)
      // row.removeEventListener('click', f)  // NOTE: had to comment this out in order to allow for reselection of table rows... maybe only necessary for children components that has table nested deeper
    })
  }

  markCurrentRowAsSelected = (selectedRow, selectedRowIndex) => {
    let table = this.getTable()
    if (table) {
      selectedRow.style.backgroundColor = 'rgba(42, 146, 73, 0.2)'
      table.style.borderCollapse = 'collapse'
      selectedRow.style.borderLeft = '5px solid green'
      let tableRows = this.getTableRows()
      tableRows.forEach((row, index) => {
        if (index !== selectedRowIndex) {
          row.style.backgroundColor = 'inherit'
          row.style.borderLeft = 'none'
        }
      })
    }
  }

  resetRowSelection = () => {
    let tableRows = this.getTableRows()
    tableRows.forEach((row, index) => {
      if (row.style.borderLeft === '5px solid green') {
        row.style.backgroundColor = 'inherit'
        row.style.borderLeft = 'none'
      }
    })
  }

  render() {
    let tableRows = this.getTableRows()
    if (tableRows) {
      tableRows.forEach(this.addClickHandler)
    }
    return (
      <div ref={this.listingComponentRef}>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/choose-table-row/index.js